/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSecurityHubFindingQueryLocation extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AwsSecurityHubFindingQueryLocation");
    }

    getFixupPrototypeFunction() { return AwsSecurityHubFindingQueryLocation.fixupPrototype; }

    static newInstance(model: Partial<AwsSecurityHubFindingQueryLocation>): AwsSecurityHubFindingQueryLocation {
        let obj = Object.assign(new AwsSecurityHubFindingQueryLocation(), model);
        AwsSecurityHubFindingQueryLocation.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSecurityHubFindingQueryLocation>): AwsSecurityHubFindingQueryLocation {
        if (!model) return null;
        return AwsSecurityHubFindingQueryLocation.newInstance(<AwsSecurityHubFindingQueryLocation> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSecurityHubFindingQueryLocation) {
        if (!obj) return;

        models.AwsSecurityHubFindingQueryLocation.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSecurityHubFindingQueryLocation): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AwsSecurityHubFindingQueryLocation.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Regions for the findings
     */
    regions: Array<string>;

}
